export default __webpack_public_path__ + "static/media/fc_intro.a705200f.png";